import { gql } from 'graphql-request'
import { transactionByIdFragment } from '../transaction'

export const orderAsClientFragment = gql`
  fragment orderAsClientType on order {
    id
    amount
    createdAt
    updatedAt
    transactions {
      id
      status
      amount
      type
      typeVariation
      paymentProviderId
      referenceId
      date
    }
    booking {
      id
      startDate
    }
    orderCardTemplates {
      price
      cardTemplate {
        type
        name
        type
      }
      cardTemplateId
    }
    orderServices {
      price
      serviceId
    }
  }
`
export const orderByIdFragment = gql`
  ${transactionByIdFragment}
  fragment orderByIdType on order {
    id
    amount
    createdAt
    updatedAt
    bookingId
    client {
      id
      firstName
      lastName
    }
    orderCardTemplates {
      price
      cardTemplate {
        name
        type
      }
      cardTemplateId
    }
    orderServices {
      price
      serviceId
    }
    transactions {
      ...transactionByIdType
    }
  }
`
